import React, { Suspense } from 'react'
import Modal, { Footer, Header, Body as ModalBody } from 'src/components/theme/Models/Modal'
import Loading from './Loading'
import Body from './Body'

interface ReportModalProps {
  id: number
  isOpen: boolean
  toggle: () => void
}

const ReportModal: React.FC<ReportModalProps> = (props) => {
  const { id, isOpen, toggle } = props

  return (
    <Modal
      title='Position Overview Report'
      isOpen={isOpen}
      toggle={toggle}
    >
      <Header title='Position Overview Report' />
      <ModalBody
        error={{
          show: false,
          error: ''
        }}
      >
        <div className='d-flex align-items-center justify-content-center w-100'>
          <Suspense fallback={<Loading />}>
            <Body id={id} />
          </Suspense>
        </div>
      </ModalBody>
      <Footer toggle={toggle} />
    </Modal>
  )
}

export default ReportModal
